import React, { memo } from 'react';

import PropTypes from 'prop-types';

import { ActionStepContentType } from 'constants/aiChat';

import {
  subStepContentComponentMap,
  subStepContentTypeGuardMap,
} from './ActionStepContent.constants';

const ActionStepContent = ({ contentType, contentProps }) => {
  const typeGuard = subStepContentTypeGuardMap[contentType];

  if (!typeGuard || !typeGuard(contentProps)) {
    return null;
  }

  const ContentComponent = subStepContentComponentMap[contentType];

  return <ContentComponent contentProps={contentProps} />;
};

ActionStepContent.propTypes = {
  contentType: PropTypes.oneOf(Object.values(ActionStepContentType)).isRequired,
  contentProps: PropTypes.object.isRequired,
};

export default memo(ActionStepContent);
